import { RewardsVipTierEntity } from "@apps/rewards/modules/VipTiers/models/RewardsVipTiersEntities";

import type { VipTiersSdkResultDTO } from "../../types";
import { mapBaseRewardToDTO } from "./mapRewardToDTO";

export const mapVIPTiersToDTO = (
    items: Array<RewardsVipTierEntity>
): Array<VipTiersSdkResultDTO> =>
    items.map((item) => ({
        id: item.id,
        title: item.title,
        description: item.description,
        perks: item.perks,
        pointsMultiplier: item.pointsMultiplier,
        image: item.image,
        condition: item.condition,
        conditionValue: item.conditionValue,
        rewarding: item.rewarding ? mapBaseRewardToDTO(item.rewarding) : null,
        isDefault: item.isDefault,
    }));
